// lib
import React, { useState, useMemo, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'

// components
import AdvancedFilter from '@aytm/app/stats/page/components/AdvancedFilter'

let timer = null

const AdvancedFilterContainer = ({
  className,
  pattern,
  parser,
  locale,
  surveySchema,
  clusters,
  parserResultEof,
  prefix,
  hintPosition,
  options = {},
  disabled,
  onChange
}) => {
  const [advancedFilterPattern, setAdvancedFilterPattern] = useState(pattern)

  const parserResultPattern = useMemo(
    () =>
      parser.analyzeString({
        filter: advancedFilterPattern.trim(),
        clusters: clusters,
        saveTokens: true,
        ...options
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [advancedFilterPattern, surveySchema, clusters]
  )

  const onPatternChange = useCallback(
    value => {
      setAdvancedFilterPattern(value)

      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        'function' == typeof onChange && onChange(value)
      }, 1000)

      return () => {
        if (timer) clearTimeout(timer)
      }
    },
    [onChange]
  )

  useEffect(() => setAdvancedFilterPattern(pattern), [pattern])

  return (
    <AdvancedFilter
      className={className || ''}
      locale={locale}
      surveySchema={surveySchema}
      pattern={advancedFilterPattern}
      parserResultEof={parserResultEof}
      parserResultPattern={parserResultPattern || parserResultEof}
      prefix={prefix}
      hintPosition={hintPosition}
      disabled={disabled}
      onChange={disabled ? null : onPatternChange}
    />
  )
}

AdvancedFilterContainer.propTypes = {
  className: PropTypes.string,
  pattern: PropTypes.string,
  parser: PropTypes.any,
  locale: PropTypes.instanceOf(Map),
  surveySchema: PropTypes.object,
  clusters: PropTypes.object,
  parserResultEof: PropTypes.object,
  prefix: PropTypes.string,
  hintPosition: PropTypes.oneOf(['top', 'bottom']),
  options: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onActive: PropTypes.func
}

AdvancedFilterContainer.displayName = 'AdvancedFilterContainer'

export default AdvancedFilterContainer
